import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/money-flow/premium/page.tsx");
